import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { logout } from './authSlice';
import api from './config';

const initialState = {
  total: 0,
  withToken: 0,
  users: [], // GET /company/:companyId/favorite-users — clients who favorited this company
  loading: false,
  isSuccess: false,
  errors: []
};

export const fetchFavoriteUsers = createAsyncThunk(
  'favoriteUsers/fetchFavoriteUsers',
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const companyId = localStorage.getItem('company');
      const response = await api.get(`/company/${companyId}/favorite-users`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) dispatch(logout());
      return rejectWithValue(error.response?.data || error);
    }
  }
);

const favoriteUsersSlice = createSlice({
  name: 'favoriteUsers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavoriteUsers.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFavoriteUsers.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.isSuccess = true;
        state.total = payload?.total || 0;
        state.withToken = payload?.withToken || 0;
        state.users = payload?.users || [];
      })
      .addCase(fetchFavoriteUsers.rejected, (state, { payload }) => {
        state.loading = false;
        state.isSuccess = false;
        if (payload?.statusCode === 400) state.errors = payload?.message;
      });
  }
});

export default favoriteUsersSlice.reducer;
